import styled, { css } from 'styled-components';
import { media, colors, mixins } from '../css';
import Text from '../BuildingBlocks/Text/Text';
import Grid from '../Utility/Grid/Grid';

export const BannerThreeContainer = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  text-align: right;
`;

export const StyledGridContainer = styled(Grid.Container)`
  ${media.lessThan('md')`
    padding-left: 0 !important;
    padding-right: 0 !important;
  `};
`;

export const ImageContainer = styled.div`
  display: inline-block;
  background-image: url(${props => props.backgroundImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 200px;

  /* fixes issue where 1px gap shows at certain sizes */
  &:nth-child(n + 2) {
    margin-left: -1px;
  }

  ${media.greaterThan('md')`
          height:340px;
        `};
  ${media.greaterThan('lg')`
          height:380px;
        `};
  ${media.greaterThan('xl')`
          height:480px;
        `};
  ${props => {
    switch (props.length) {
      case 1:
        return css`
          width: 100%;
        `;

      case 2:
        return css`
          width: 100%;
          ${media.greaterThan('lg')`
          width: 65%;
        `};
        `;

      default:
        return css`
          width: 100%;
          ${media.greaterThan('lg')`
            width: 65%;
          `};

          ${media.greaterThan('xl')`
          width: 48%;
      
        `};
        `;
    }
  }};
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: ${mixins.pxToRem(30)};
  right: 0;
  width: calc(100% - 16px);
  margin: 0 ${mixins.pxToRem(8)};
  ${media.greaterThan('lg')`
    width: auto;
    right: ${mixins.pxToRem(30)};
  `};
`;

export const StyledHeadingFourth = styled(Text.HeadingFourth)`
  margin: 0;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const StyledDescriptionText = styled(Text.CopyParagraph)`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ModalHeadingContainer = styled.div`
  height: ${mixins.pxToRem(65)};
  padding: ${mixins.pxToRem(22)} ${mixins.pxToRem(12)} 0 0;
`;
export const ModalImageContainer = styled.div`
  height: calc(100vh - 130px);
  position: relative;
  img {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    user-select: none;
  }
`;

export const ModalParaContainer = styled.div`
  height: ${mixins.pxToRem(65)};
  overflow: hidden;
`;

export const NavButton = styled.button`
  position: absolute;
  top: 50%;
  background-color: ${colors.colorGreyRgba(0.5)};
  outline: none;
  padding: ${mixins.pxToRem(5)} ${mixins.pxToRem(16)};
  cursor: pointer;
  svg {
    cursor: pointer;
  }

  ${props => {
    const { side } = props;
    if (side === 'prev') {
      return css`
        left: ${mixins.pxToRem(-9)};
        transform: rotate(90deg);
      `;
    }
    return null;
  }};

  ${props => {
    const { side } = props;
    if (side === 'next') {
      return css`
        right: ${mixins.pxToRem(-9)};
        transform: rotate(-90deg);
      `;
    }
    return null;
  }};

  ${media.greaterThan('md')`
    background-color: transparent;
  `};
`;

export const PreloadedImage = styled.img`
  visibility: hidden;
  width: 0;
  height: 0;
  overflow: hidden;
`;
